<template>
  <router-view />
</template>

<script>
  import { mapMutations } from 'vuex'
  import basicMixin from './mixins/basic'
  import {
    SW_SET_REGISTRATION, SW_SET_UPDATE_AVAIL, SW_SET_UPDATE_READY,
  } from './store/mutations.types'

  export default {
    name: 'App',
    mixins: [basicMixin],
    data: () => ({
      refreshing: false,
    }),
    methods: {
      ...mapMutations({
        setUpdateAvail: SW_SET_UPDATE_AVAIL,
        setUpdateReady: SW_SET_UPDATE_READY,
        setSWRegistration: SW_SET_REGISTRATION,
      }),
      appSWUpdating: function (e) {
        console.log('testing:')
        console.log('ServiceWorkerUpdating:', e.detail)
        this.setSWRegistration(e.detail)
        this.setUpdateAvail(true)
      },
      appSWUpdated: function (e) {
        console.log('testing:')
        console.log('ServiceWorkerUpdating:', e.detail)
        this.setSWRegistration(e.detail)
        this.setUpdateReady(true)
      },
    },
    created () {
      document.addEventListener(
        'swUpdated', this.appSWUpdated, { once: true },
      )
      document.addEventListener(
        'swUpdating', this.appSWUpdating, { once: true },
      )
      navigator.serviceWorker.addEventListener(
        'controllerchange', () => {
          if (this.refreshing) return
          this.refreshing = true
          window.location.reload()
        },
      )
    },
  }
</script>
